import {
  Button,
  FormField,
  Modal,
  RangeDatePicker,
  TextInput,
  Variants
} from "@sede-x/shell-ds-react-framework";
import dayjs, { Dayjs } from "dayjs";
import { useState } from "react";
import { TOutboundMovementSearchCriteria } from "./tracker.types";

export const OutboundMovementsSearch = ({
  open,
  searchCriteria,
  onClose,
  onSubmit
}: {
  open: boolean;
  searchCriteria: TOutboundMovementSearchCriteria;
  onClose: () => void;
  onSubmit: (elm: TOutboundMovementSearchCriteria) => void;
}) => {
  const [localSearchCriteria, setLocalSearchCriteria] =
    useState<TOutboundMovementSearchCriteria>(searchCriteria);

  const disabledDate = (current: Dayjs) =>
    current
      ? current.isBefore(new Date("2024-08-01"), "date") || current.isAfter(new Date(), "date")
      : false;
  return (
    <Modal
      title="Search outbound movements queue"
      width={"800px"}
      height={"600px"}
      mask={true}
      open={open}
      onClose={onClose}>
      <form
        onSubmit={e => {
          e.preventDefault();
          onSubmit(localSearchCriteria);
        }}>
        <FormField size={"medium"} label="Queued between">
          <RangeDatePicker
            picker="date"
            format="MM/DD/YYYY"
            allowClear={true}
            disabledDate={disabledDate}
            autoFocus
            value={[dayjs(localSearchCriteria.startDate), dayjs(localSearchCriteria.endDate)]}
            onChange={values => {
              setLocalSearchCriteria(c => ({
                ...c,
                startDate: values?.[0]?.toISOString() ?? "",
                endDate: values?.[1]?.toISOString() ?? ""
              }));
            }}
          />
        </FormField>
        <FormField size={"medium"} label="Delivery Id">
          <TextInput
            placeholder="Comma seperated delivery ids"
            value={localSearchCriteria.endurDeliveryId}
            onChange={e =>
              setLocalSearchCriteria(c => ({
                ...c,
                endurDeliveryId: e.target.value
              }))
            }
          />
        </FormField>
        <FormField size={"medium"} label="Batch name">
          <TextInput
            placeholder="Comma seperated batch names"
            value={localSearchCriteria.endurBatchName}
            onChange={e =>
              setLocalSearchCriteria(c => ({
                ...c,
                endurBatchName: e.target.value
              }))
            }
          />
        </FormField>
        <div style={{ paddingBottom: "120px" }}></div>
        <div className="from-button-wrap">
          <Button variant={Variants.Outlined} onClick={onClose}>
            Cancel
          </Button>
          <Button type="submit">Search</Button>
        </div>
      </form>
    </Modal>
  );
};
